





































































































































































import BaseComponent from '@/components/base-component.vue';
import PatientAddress from '@/components/patients/patient-address.vue';
import UiAutocompleClientsSubsidiaries from '@/components/UI/autocomplete-clients-subsidiaries.vue';
import UiDatePicker from '@/components/UI/date-picker.vue';
import UiGenderPicker from '@/components/UI/gender-picker.vue';
import InputMoney from '@/components/UI/input-money.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import UiSelectClients from '@/components/UI/select-clients.vue';
import { dateFormat } from '@/helpers/dateFormat';
import { toNumber } from '@/helpers/toNumber';
import { toUpperCase } from '@/helpers/toUpperCase';
import { hasSpecialCharacters } from '@/helpers/validations';
import { validPersonName } from '@/helpers/validPersonName';
import { PacienteExistFiltrosDTO, PacienteParmDTO } from '@/interfaces/patient';
import PatientModel from '@/models/patient-model';
import * as service from '@/services/patients';
import { PATIENT_NEWBORN_TYPES } from '@/settings/consts/patient';
import * as moment from 'moment';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import PatientAddressMultiClientUnit from './patient-address-multi-client-unit.vue';
import PatientExistsDialog from './patient-exists-dialog.vue';
import PatientMergeDialog from './patient-merge-dialog.vue';

@Component({
  components: {
    PermissionAuth,
    UiDatePicker,
    UiGenderPicker,
    UiSelectClients,
    InputMoney,
    UiAutocompleClientsSubsidiaries,
    PatientAddress,
    PatientMergeDialog,
    PatientAddressMultiClientUnit,
    PatientExistsDialog
  },
})
export default class PatientForm extends BaseComponent {
  @Prop()
  public isEdit: boolean = false;
  @Prop()
  public id: number;
  @Prop()
  public subsidiary?: any;
  @Prop({ default: false })
  public lockStatus?: boolean;

  formOpen = false;

  public showTermoInput: boolean = false;
  

  public currentTab: string = 'tab-dados';

  public headers: any = [
    { text: 'Nome', value: 'nome', sortable: false },
    { text: 'Data de Nascimento', value: 'nascimento', sortable: false },
    { text: 'Sexo', value: 'sexo', sortable: false },
    { text: 'Peso', value: 'peso', sortable: false },
    { text: 'Same', value: 'same', sortable: false },
    { text: 'Status', value: 'status', sortable: false },
    { text: 'Unidades', value: 'unidades', sortable: false },
  ];

  showAgregateDialogFlag = false;

  listPatientsExist = [];
  showPatientExistsDialogFlag = false;

  public form: any = {
    valid: false,
    rules: {
      name: [(v) => !!v || 'Informe o Nome completo', (v) => (!!v && validPersonName(v, true)) || 'Nome completo inválido'],
      birthday: [
        (value) => {
          const birthdayUnix = toNumber(
            dateFormat(value, 'UNIX', 'DDMMYYYY', true),
          );
          const todayUnix = toNumber(
            dateFormat(dateFormat(), 'UNIX', 'DDMMYYYY', true),
          );
          if (!value) {
            return 'Digite a data de nascimento';
          } else if (
            !birthdayUnix ||
            !moment(birthdayUnix).isValid() ||
            birthdayUnix > todayUnix
          ) {
            return 'Digite uma data de nascimento válida';
          }

          return true;
        },
      ],
      weight: [
        (v) => !!v || 'Digite o peso',
        (v) => toNumber(v) > 0 || 'O peso do paciente precisa ser maior que 0',
      ],
      same: [(v) => hasSpecialCharacters(v)],
      term: [(v) => !!v || 'Selecione um termo'],
      register: [(v) => !!v || 'Digite o numero de registro'],
      gender: [(v) => !!v || 'Selecione o sexo'],
      clientUnit: [(v) => !!v || 'Selecione uma unidade'],
    },
  };

  public $refs!: {
    form: HTMLFormElement;
  };

  public item: any = new PatientModel();
  public itemOrig: any = {};

  public maxBirthdayDate: string = null;

  public patientTypes: any[] = [];
  public patientType = null;

  get clientUnit() {
    return !!this.item.unidades.length ? this.item.unidades[0] : null;
  }

  set clientUnit(val) {
    if (!!val) {
      this.item.unidades = [val];
    } else {
      this.item.unidades = [];
    }
  }

  public beforeMount(): void {
    this.maxBirthdayDate = dateFormat(null, 'US');
    this.getPatientTypes();
    this.formOpen = true;
  }

  @Watch('id', {immediate: true})
  public watchId(id): void {
    if (!id) {
      this.item = new PatientModel();
      this.prepareForm();
      return;
    }
    this.loader.start('Carregando item...');
    service.getPatientDetails(id).subscribe(
      (data) => {
        this.item = data;
        this.loader.stop();
        this.prepareForm();
      },
      () => {
        this.loader.stop();
        this.toast.show('Ocorreu um erro ao carregar o item', 'error');
        this.$emit('close');
      },
    );
  }

  public prepareForm(): void {
    this.patientType = null;
    this.setSubsidiary();
    this.checkShowTermoInput();
    this.currentTab = 'tab-dados';
    setTimeout(() => {
      this.$refs['nome'].focus();
    }, 300);
  }

  public saveItem(): void {
    this.$refs.form.validate();
    if (!this.form.valid) {
      return;
    }

    this.loader.start('Salvando registro...');

    let parm = new PacienteParmDTO();
    parm.id = this.item.id;
    parm.nome = this.item.nome;
    parm.nascimento = this.item.nascimento;
    parm.sexo = this.item.sexo;
    parm.peso = this.item.peso;
    parm.termo = this.item.termo;
    parm.same = this.item.same;
    parm.idsUnidades = this.item.unidades ? this.item.unidades.map(u => u.id) : [];
    parm.idsEnderecos = this.item.enderecos ? this.item.enderecos.map(e => e.id) : [];
    parm.ativo = this.item.ativo;

    if (this.subsidiary) {
      parm.idUnidadePrescrever = this.subsidiary.id;
    }

    let obs = null
    if (!this.item.id) {
      obs = service.savePatient(parm);
    }else {
      obs = service.updatePatient(parm);
    }
    obs.subscribe(res => {
      this.loader.stop();
      this.$emit('save', res);
    }, error => {
      this.loader.stop();
      this.showToastApiError(error);
    });
  }

  public closeForm(): void {
    const closeAction = () => {
      this.$emit('close');
    };

    this.dialog.show(
      'error',
      'Sair sem salvar',
      'Deseja sair sem salvar as alterações?',
      'Cancelar',
      '',
      'Sair',
      closeAction,
    );
  }

  private setSubsidiary(): void {
    if (!!this.subsidiary && this.subsidiary.id) {
      this.item.unidades = [];
      this.item.unidades.push(this.subsidiary);      
      if (!this.item.unidades[0].enderecos || !this.item.unidades[0].enderecos.length) {
        service.getPatientClientUnitDetails(this.subsidiary.id).subscribe((uni) => {
          this.item.unidades = [];
          this.item.unidades.push(uni);          
        });
      }
    }
  }

  private getPatientTypes(): void {
    const patientTypes = PATIENT_NEWBORN_TYPES;
    for (const patientType in patientTypes) {
      if (patientTypes.hasOwnProperty(patientType)) {
        this.patientTypes.push({
          value: toUpperCase(patientType),
          label: toUpperCase(patientTypes[patientType]),
        });
      }
    }
  }
  public checkShowTermoInput(){
    if(!this.item.nascimento){
      this.showTermoInput = false
      this.item.termo = null;
      return;
    }

    service.getPatientTypes(this.clientUnit ? this.clientUnit.id : null, this.item.nascimento)
      .subscribe(result => {
        this.patientType = result;
        this.showTermoInput = result.showTermo;        
      });
  }

  showAgregateDialog() {
    this.showAgregateDialogFlag = true;
  }

  closeMergeDialog() {
    this.showAgregateDialogFlag = false;
  }

  onSaveMerge(res) {
    this.item = res;
    this.closeMergeDialog();
    this.$emit('merged', res);
  }

  onChangeNomeNascimentoUnidades() {
    if (this.item.id) {
      return;
    }

    if (!this.item.nome || !this.item.nascimento || !this.item.unidades || !this.item.unidades.length) {
      return;
    }
    
    let f = new PacienteExistFiltrosDTO();
    f.idsUnidade = this.item.unidades.map(u => u.id);
    f.nomePaciente = this.item.nome;
    f.nascimento = this.item.nascimento;
    service.listPatientsExistClient(f).subscribe(res => {
      if (res.length) {
        this.listPatientsExist = res;
        this.showPatientExistsDialogFlag = true;
      }
    }, error => {
      this.loader.stop();
      this.showToastApiError(error);
    }); 
  }

  onPatientExistsDialogDone(id) {
    this.showPatientExistsDialogFlag = false;
    if (!id) {
      return;
    }

    this.loader.start('Preparando ... ')
    service.getPatientDetails(id).subscribe(res => {
      let unidades = Object.assign(new Array(), this.item.unidades);
      let enderecos = Object.assign(new Array(), this.item.enderecos);

      this.item = res;
      if (this.subsidiary && this.subsidiary.id) {
        this.item.unidades = this.item.unidades.filter(u => u.id == this.subsidiary);
      }
      this.itemOrig = {...res};
      this.loader.stop;
      unidades.forEach(u => {
        if (!this.item.unidades.find(i => i.id == u.id)) {
          this.item.unidades.push(u);
        }
      });
      enderecos.forEach(e => {
        if (!this.item.enderecos.find(i => i.id == e.id)) {
          this.item.enderecos.push(e);
        }
      });
      this.dialog.show(
        'alert', 
        'Atenção!', 
        'O formulário foi preparado para alteração do paciente já cadastrado.'
      );
    },error => {

    })
  }
}
